import React from 'react';
import PropTypes from 'prop-types';
import { ValidatingInput, Message } from '../../';

export default class PaypalAccount extends React.Component {
    static propTypes = {
        payPalSchema: PropTypes.object,
        onChange: PropTypes.func,
        getValue: PropTypes.func,
        disabled: PropTypes.bool
    };
    render() {
        const { payPalSchema, onChange, getValue, disabled } = this.props;
        return (
            <div>
                <h2>
                    <Message code="epic.esport.label.paypal_account" />
                </h2>
                <div className="row">
                    <ValidatingInput
                        disabled={disabled}
                        customClassNames="col-xs-12 col-md-8 col-lg-6 code-input"
                        name={payPalSchema.identifier}
                        value={getValue(payPalSchema.identifier)}
                        placeholder={payPalSchema.display.text}
                        onChange={onChange(payPalSchema.identifier)}
                        validations={disabled ? {} : payPalSchema.validations}
                        validationErrors={payPalSchema.validationMessages}
                        required={payPalSchema.required}
                    />
                </div>
            </div>
        );
    }
}
